import { CodatCompanyRefreshRequestStatus } from '@40seas/entities/codat-company-refresh-requests';
import { EnumColor } from '@40seas/frontend/common/providers';

export const codatCompanyRefreshRequestStatusMapping = {
    [CodatCompanyRefreshRequestStatus.Pending]: 'default',
    [CodatCompanyRefreshRequestStatus.InProgress]: 'info',
    [CodatCompanyRefreshRequestStatus.Succeeded]: 'success',
    [CodatCompanyRefreshRequestStatus.Failed]: 'error',
} as { [key in CodatCompanyRefreshRequestStatus]: EnumColor };
